module.exports = __webpack_public_path__ + "img/6c8762a.svg";